import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";

export function NewActionButton({ ...props }) {
    return <IconButton
        title="New"
        data-cy="new-action-button"
        className="fa fa-plus"
        size="small"
        sx={{ color: "primary.main" }}
        {...props}
    />;
};

export function EditActionButton({ ...props }) {
    return <IconButton
        title="Edit"
        data-cy="edit-action-button"
        className="fa fa-pencil"
        size="small"
        sx={{ color: "goldenrod" }}
        {...props}
    />;
};

export function DeleteActionButton({ ...props }) {
    return <IconButton
        title="Delete"
        className="fa fa-trash-alt"
        size="small"
        data-cy="delete-action-button"
        {...props}
    />;
};

export function CopyRefButton({ info, ...props }) {
    function handleCopyAction() {
        navigator.clipboard.writeText(info);
    };

    return (<IconButton
        className="fa fa-clipboard"
        size="small"
        color="inherit"
        {...props}
        onClick={handleCopyAction}
    />);
};


export const SpinningRefreshIcon = ({ inProgress }) => (<RefreshIcon sx={!inProgress ? {} : {
    animation: "spin 5s linear infinite",
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
}}
/>);

export const MyButton = ({ icon, children, ...props }) => (<Button
    size="small"
    startIcon={icon}
    sx={{ "& .MuiButton-startIcon": { marginRight: "2px" } }}
    {...props}
>
    {children}
</Button>);
